const MobileTabs = (props) => {
  const handleTabSelection = (IsCreditsTab) => {
    if (IsCreditsTab) {
      props.SwitchTab(true);
    } else {
      props.SwitchTab(false);
    }
  };

  return (
    <div className="home-tabs-wrapper">
      <section className="tabs-rail">
        <span
          className={
            props.CreditsTabIsSelected ? "tab-item selected-tab" : "tab-item"
          }
          onClick={() => handleTabSelection(true)}
          id="credits-tab-item"
        >
          Credits
        </span>
        <span
          className={
            !props.CreditsTabIsSelected ? "tab-item selected-tab" : "tab-item"
          }
          onClick={() => handleTabSelection(false)}
          id="profile-tab-item"
        >
          Profile
        </span>
        <span
          className={
            !props.CreditsTabIsSelected ? "indicator" : "indicator transformed"
          }
        ></span>
      </section>
    </div>
  );
};

export default MobileTabs;
